// extracted by mini-css-extract-plugin
module.exports = {"container":"FiltersModalContentV2_container__3SB4T","section":"FiltersModalContentV2_section__0pLEz","sectionHeader":"FiltersModalContentV2_sectionHeader__3_lms"};